/**
 * In-memory persist открытости collapsible-секций карточки на сессию вкладки
 * (ключ: objectId + sectionKey).
 */

const store = new Map<string, Map<string, boolean>>();

function objectBucket(objectId: number | string): Map<string, boolean> {
  const key = String(objectId);
  let bucket = store.get(key);
  if (!bucket) {
    bucket = new Map();
    store.set(key, bucket);
  }
  return bucket;
}

export function getCardSectionOpen(
  objectId: number | string | null | undefined,
  sectionKey: string,
  fallback: boolean,
): boolean {
  if (objectId == null) return fallback;
  const v = objectBucket(objectId).get(sectionKey);
  return v === undefined ? fallback : v;
}

export function setCardSectionOpen(
  objectId: number | string | null | undefined,
  sectionKey: string,
  open: boolean,
): void {
  if (objectId == null) return;
  objectBucket(objectId).set(sectionKey, open);
}
